import React, { Component, Fragment } from "react";
import _ from 'lodash';
import DeviceView from './DeviceView';

export default class DevicesList extends Component {
  state = {
    devicesArray: [],
  };

  constructor(props) {
    super(props);

    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { devices } = nextProps;
    let devicesArray = [];

    for (let [key, value] of Object.entries(devices)) {
      const device = {
        key,
        ...value,
      };
      devicesArray.push(device);
    }

    return {
      ...prevState,
      devicesArray,
    }
  }

  onDeleteClick(deviceId) {
    const { onDelete } = this.props;

    if (onDelete) {
      onDelete(deviceId)
    }
  }

  render() {
    const { devicesArray } = this.state;

    return (
      <Fragment>
        {devicesArray.map(device => (
          <DeviceView
            key={device.key}
            device={device}
            onDeleteClick={this.onDeleteClick}
          />
        ))}
        {_.isEmpty(devicesArray) && (
          <p>No devices currently registered for this merchant</p>
        )}
      </Fragment>
    )
  }
}